module.exports = __webpack_public_path__ + "img/zoeva1.b01834b5.jpg";